"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_Contract_Term = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Identifier_1 = require("./RTTI_Identifier");
var RTTI_dateTime_1 = require("../Scalar/RTTI_dateTime");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_Period_1 = require("./RTTI_Period");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var RTTI_Reference_1 = require("./RTTI_Reference");
var RTTI_Contract_SecurityLabel_1 = require("./RTTI_Contract_SecurityLabel");
var RTTI_Contract_Offer_1 = require("./RTTI_Contract_Offer");
var RTTI_Contract_Asset_1 = require("./RTTI_Contract_Asset");
var RTTI_Contract_Action_1 = require("./RTTI_Contract_Action");
exports.RTTI_Contract_Term = t.recursion('IContract_Term', function () {
    return t.intersection([
        t.type({
            offer: RTTI_Contract_Offer_1.RTTI_Contract_Offer
        }),
        t.partial({
            id: t.string,
            extension: t.array(RTTI_Extension_1.RTTI_Extension),
            modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
            identifier: RTTI_Identifier_1.RTTI_Identifier,
            issued: RTTI_dateTime_1.RTTI_dateTime,
            _issued: RTTI_Element_1.RTTI_Element,
            applies: RTTI_Period_1.RTTI_Period,
            topicCodeableConcept: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            topicReference: RTTI_Reference_1.RTTI_Reference,
            type: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            subType: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            text: t.string,
            _text: RTTI_Element_1.RTTI_Element,
            securityLabel: t.array(RTTI_Contract_SecurityLabel_1.RTTI_Contract_SecurityLabel),
            asset: t.array(RTTI_Contract_Asset_1.RTTI_Contract_Asset),
            action: t.array(RTTI_Contract_Action_1.RTTI_Contract_Action),
            group: t.array(exports.RTTI_Contract_Term)
        })
    ]);
});
//# sourceMappingURL=RTTI_Contract_Term.js.map